import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const unableToVerifyIncomeMutation = gql`
  mutation unableToVerifyIncome(
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
    $incomeId: String!
    $userId: String!
    $reason: String
  ) {
    unableToVerifyIncome(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
      incomeId: $incomeId
      userId: $userId
      reason: $reason
    )
  }
`

export type MutationVars = {
  customerId: string
  applicationId: string
  subjectId: string
  incomeId: string
  userId: string
  reason?: string
}

export type UnableToVerifyData = {
  unableToVerify: string | unknown
}

export const useUnableToVerifyIncomeMutation: WrappedMutation<
  UnableToVerifyData,
  MutationVars
> = () =>
  useMutation<UnableToVerifyData, MutationVars>(unableToVerifyIncomeMutation, {
    client: agentClient,
  })
